import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink,BrowserRouter,useHistory   } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import config from '../../config';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import {getSignup} from '../Actions/AuthAction';


const required = (value) => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
      );
    }
  };

  
const Signup = (props) => {
  
  const form = useRef();
  const checkBtn = useRef();
  const [firstname, setFirstname] = useState({ value:  '', error: '', isRequired: true });
  const [lastname, setLastname] = useState({ value:  '', error: '', isRequired: true });
  const [email, setEmail] = useState({ value:  '', error: '', isRequired: true });
  const [mobileno, setMobileno] = useState({ value:  '', error: '', isRequired: true });
  const [password, setPassword] = useState({ value:  '', error: '', isRequired: true });
  const [confirmpassword, setConfirmassword] = useState({ value:  '', error: '', isRequired: true });
  const [referalcode, setReferalcode] = useState({ value:  '', error: '', isRequired: true });
 

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
 
  let history = useHistory();

  useEffect(() => {

    
    
  }, [])

  // const onChangeUsername = (e) => {
  //   const username = e.target.value;
  //  // alert(username);
  //   setUsername(username);
  // };

  // const onChangePassword = (e) => {
  //   const password = e.target.value;
  //   setPassword(password);
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    //localStorage.setItem("test", 'dfasdf');
    //alert(password);return false;

    setMessage("");
    setLoading(true);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {

        if(password.value != confirmpassword.value){
            setMessage("Please enter the match password");
            setLoading(false);
            return false;

        }

    getSignup({ "refferalcode":referalcode.value,"email":email.value,"firstname":firstname.value,"lastname":lastname.value,"mobile":mobileno.value,"password":password.value })
    .then(res => {
             //alert(res);
             if(res.status){
                
                setMessage("Signup Successfully...");
                
                history.push("/");
                 //window.location.reload();
              }else{
                setMessage(res.msg);
                setLoading(false);
                return false;
              }
             
      })
} else {
    setLoading(false);
  }
    
  };
        return (
            
<div className="authentication">
    <div className="container">
        <div className="row">
            <div className="col-lg-6 col-sm-12">
            <Form className="card auth_form" ref={form}>
                
                    <div className="header">
                        <img className="logo" src="assets/images/logo.svg" alt=""/>
                        <h5>Sign Up</h5>
                    </div>
                    <div className="body">
                        <div className="input-group mb-3">
                            <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter Firstname"
                            name="firtname"
                            value={firstname.value}
                            onChange={(e) => setFirstname({ ...firstname, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>
                        <div className="input-group mb-3">
                            <Input
                                type="text"
                                className="form-control"
                                name="lastname"
                                placeholder="Enter Lastname"
                                value={lastname.value}
                                onChange={(e) => setLastname({ ...lastname, value: e.target.value })}
                                validations={[required]}
                            />
                        </div>

                        <div className="input-group mb-3">
                            <Input
                            type="email"
                            className="form-control"
                            placeholder="Enter Email"
                            name="email"
                            value={email.value}
                            onChange={(e) => setEmail({ ...email, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>

                        <div className="input-group mb-3">
                            <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter mobile"
                            name="mobileno"
                            maxlength="10"
                            autoComplete="off"
                            value={mobileno.value}
                            onChange={(e) => setMobileno({ ...mobileno, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>
                        <div className="input-group mb-3">
                            <Input
                            type="password"
                            className="form-control"
                            placeholder="Enter Password"
                            name="password"
                            value={password.value}
                            onChange={(e) => setPassword({ ...password, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>

                        <div className="input-group mb-3">
                            <Input
                            type="password"
                            className="form-control"
                            placeholder="Enter Confirm Password"
                            name="confirmpassword"
                            value={confirmpassword.value}
                            onChange={(e) => setConfirmassword({ ...confirmpassword, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>

                        <div className="input-group mb-3">
                            <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter Referal Code"
                            name="referalcode"
                            value={referalcode.value}
                            onChange={(e) => setReferalcode({ ...referalcode, value: e.target.value })}
                            validations={[required]}
                        />
                        </div>

                        
                        <div className="form-group">
                            <button onClick={handleSubmit} className="btn btn-primary btn-block">
                            SIGN UP
                            </button>
                            {loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                        </div>

                            {message && (
                                <div className="form-group">
                                <div className="alert alert-danger" role="alert">
                                    {message}
                                </div>
                                </div>
                            )}
                            <CheckButton style={{ display: "none" }} ref={checkBtn} />
                        <div className="signin_with mt-3">
                            <p className="mb-0">or <Link  to="/">You already have a membership?</Link> </p>
                        </div>
                    </div>
                </Form>
                {/* <div className="copyright text-center">
                    &copy;
                    <script>document.write(new Date().getFullYear())</script>,
                    <span><a href="templatespoint.net">Templates Point</a></span>
                </div> */}
            </div>
            <div className="col-lg-6 col-sm-12">
                <div className="card">
                    <img src="assets/images/signin.svg" alt="Sign In"/>
                </div>
            </div>
        </div>
    </div>
</div>
        )
    
}


export default Signup